// extracted by mini-css-extract-plugin
export default {"button":"styles_button__VN6VG","link":"styles_link__qMIwn"};